import { bankDetailTranslations } from "Infrastructure/Translation/en/bankDetail";
import { claimTranslations } from "Infrastructure/Translation/en/claim";
import { commentTranslations } from "Infrastructure/Translation/en/comment";
import companyTranslations from "Infrastructure/Translation/en/company";
import { examinationTranslations } from "Infrastructure/Translation/en/examination";
import { generalSetupTranslations } from "Infrastructure/Translation/en/generalSetup";
import { invoiceTranslations } from "Infrastructure/Translation/en/invoice";
import { marketTranslations } from "Infrastructure/Translation/en/market";
import { menuTranslations } from "Infrastructure/Translation/en/menu";
import orderTranslations from "Infrastructure/Translation/en/order";
import { orderSetupTranslations } from "Infrastructure/Translation/en/orderSetup";
import { partnerTranslations } from "Infrastructure/Translation/en/partner";
import { paymentTranslations } from "Infrastructure/Translation/en/payment";
import { settingsTranslations } from "Infrastructure/Translation/en/settings";
import userTranslations from "Infrastructure/Translation/en/user";
import { utilitiesTranslations } from "Infrastructure/Translation/en/utilities";
import type { BaseTranslations } from "Infrastructure/Translation/Types/base";

const defaultTranslations: BaseTranslations = {
	menu: menuTranslations,
	order: orderTranslations,
	partner: partnerTranslations,
	user: userTranslations,
	claim: claimTranslations,
	company: companyTranslations,
	market: marketTranslations,
	utilities: utilitiesTranslations,
	invoice: invoiceTranslations,
	orderSetup: orderSetupTranslations,
	bankDetail: bankDetailTranslations,
	settings: settingsTranslations,
	generalSetup: generalSetupTranslations,
	payment: paymentTranslations,
	examination: examinationTranslations,
	comment: commentTranslations,
};

export default defaultTranslations;
